import {ReactNode, useState} from "react";
import styled from "styled-components";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";

interface Props extends ButtonProps {
	children: ReactNode;
	onClick?: () => void;
}

const Button = styled.button<{showAfter: boolean}>`
	display: flex;
	width: 350px;
	height: 56px;
	margin: 20px auto 0;
	border: 1px solid var(--emp-color);
	background-color: #fff;
	align-items: center;
	justify-content: center;
	font-family: "PT-regular";

	em {
		position: relative;
		padding-left: 24px;
		color: var(--emp-color);
		font-size: 16px;
		line-height: 1;

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			width: 14px;
			height: 2px;
			background-color: var(--emp-color);
			transform: translateY(-50%);
			content: "";
		}

		&:after {
			position: absolute;
			left: 6px;
			top: 50%;
			width: 2px;
			height: 14px;
			background-color: var(--emp-color);
			transform: translateY(-50%);
			content: "";
		}

		${props =>
			props.showAfter &&
			`
		&:after {
			display: none;
		}
		`}
	}
`;

const PlusMoreButton = ({children, onClick}: Props) => {
	const [showAfter, setShowAfter] = useState(false);

	const handleClick = () => {
		setShowAfter(!showAfter);
		if (onClick) {
			onClick();
		}
	};
	return (
		<Button onClick={handleClick} showAfter={showAfter}>
			<em>{children}</em>
		</Button>
	);
};

export default PlusMoreButton;
